export const WISHLIST_ITEMS_LIST = "WISHLIST_ITEMS_LIST"
export const ADD_WISHLIST_ITEM = "ADD_WISHLIST_ITEM"
export const DELETE_WISHLIST_ITEM = "DELETE_WISHLIST_ITEM"
